<template>
  <div>
    <div class="comm_popup_wrap_small">
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-2 col-xs-4">
            <sui-input-label
              :label="$t('MSG_TXT_VALID_PERIOD')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-8">
            <sui-date-picker
              v-model="finDt"
              :disabled="false"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="comm_btn_wrap mrR30">
      <sui-button
        type="button"
        class="comm_btn_border"
        @click="onCancel"
      >
        {{ $t('MSG_BTN_CANCEL') }}
      </sui-button>
      <sui-button
        type="button"
        class="comm_btn_solid"
        @click="onConfirm"
      >
        {{ $t('MSG_BTN_CFRM') }}
      </sui-button>
    </div>
  </div>
</template>
<script>
// import - libraries (node modules)
// import - local files (js, vue, ...)
export default {
  name: 'PGE_CMA_00007_P01', // eslint-disable-line vue/name-property-casing
  data() {
    return {
      finDt: '9999-12-31',
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onCancel() {
      this.$emit('cancel', '');
    },
    onConfirm() {
      this.$emit('confirm', this.finDt);
    },

  },
};
</script>
<style scoped>
</style>
<style scoped>
</style>
